import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: [],
}

export const operationalPeriods: any = createSlice({
    name: 'OPERATIONAL_PERIODS',
    initialState,
    reducers: {
        setOperationalPeriods: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setOperationalPeriods } = operationalPeriods.actions

export default operationalPeriods.reducer
